<template>
  <b-modal id="modal-settings" :title="$t('settings')">
    <template #modal-header>
      <h4>
        {{ data.id ? $t("edit_settings") : $t("created_settings") }}
      </h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('modal-settings')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-overlay :show="settingsLoading" class="rounded" variant="transparent">
      <template #overlay>
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
      </template>
      <form @submit.prevent>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <base-input
              :label="$t('key')"
              :placeholder="$t('key')"
              input-classes="form-control-alternative border"
              v-model="data.key"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('key')"
              name="key"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('key')"
              ><small>{{ errors.first("key") }}</small></span
            >
          </div>
          <div class="col-md-6">
            <base-input
              :label="$t('value')"
              :placeholder="$t('value')"
              input-classes="form-control-alternative border"
              v-model="data.value"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('value')"
              name="value"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('value')"
              ><small>{{ errors.first("value") }}</small></span
            >
          </div>
        </div>
      </form>
    </b-overlay>

    <template #modal-footer>
      <b-button size="sm" variant="primary" @click="add">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('modal-settings')"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      data: {
        id: "",
        key: "",
        value: "",
      },
    };
  },
  methods: {
    ...mapActions({
      settingsCreateUpdate: "settingsCreateUpdate",
    }),
    async add() {
      const res = await this.settingsCreateUpdate(this.data);
      if (res.status === 200) {
        this.$toast.success(res.message, {
          position: "top-right",
        });
        this.$emit("refresh");
        this.$bvModal.hide("modal-settings");
      }
    },
    show(item) {
      this.data = {
        id: "",
        key: "",
        value: "",
      };
      if (item) {
        this.data = {
          id: item.id,
          key: item.key,
          value: item.value,
        };
      }
      this.$bvModal.show("modal-settings");
    },
  },
  computed: {
    ...mapGetters({
      settingsLoading: "settingsLoading",
    }),
  },
};
</script>